<template>
  <div class="event-public-page">
    <div id="eventHeroCarousel" class="carousel slide event-hero" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button
          v-for="(b, idx) in heroBanners"
          :key="'hero-ind-' + idx"
          type="button"
          data-bs-target="#eventHeroCarousel"
          :data-bs-slide-to="idx"
          :class="{ active: idx === 0 }"
          :aria-current="idx === 0 ? 'true' : 'false'"
          :aria-label="'Slide ' + (idx + 1)"
        ></button>
      </div>
      <div class="carousel-inner">
        <div v-for="(b, idx) in heroBanners" :key="'hero-' + idx" class="carousel-item" :class="{ active: idx === 0 }">
          <div class="event-hero-slide" :style="{ backgroundImage: `url(${b.url})` }">
            <div class="event-hero-mask">
              <div class="event-hero-content">
                <div class="event-hero-title">{{ b.title }}</div>
                <div class="event-hero-subtitle">{{ b.subtitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#eventHeroCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#eventHeroCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div class="container event-public-body">
      <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-3">
        <div>
          <h2 class="mb-1">赛事介绍</h2>
          <div class="text-muted small">选择赛季后浏览该赛季的赛事列表与入口。</div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <div class="text-muted small">赛季</div>
          <select v-model="selectedSeason" class="form-select form-select-sm" style="min-width: 160px;">
            <option v-for="s in seasonOptions" :key="'season-' + s" :value="s">{{ s }}年赛季</option>
          </select>
        </div>
      </div>

      <div v-if="filteredEvents.length === 0" class="alert alert-light border text-muted">
        暂无该赛季赛事数据。
      </div>

      <div v-for="ev in filteredEvents" :key="'ev-' + ev.id" class="card event-tag-card mb-3" :class="{ 'event-tag-card-ended': Number(ev.enabled) === 0 }">
        <div class="card-body">
          <div v-if="Number(ev.enabled) === 0" class="event-ended-mark">已结束</div>
          <div class="row g-3 align-items-stretch">
            <div class="col-12 col-md-3 col-lg-2">
              <div class="event-tag-cover">
                <img v-if="ev.coverUrl" :src="ev.coverUrl" class="event-tag-cover-img" :alt="ev.title" />
                <div v-else class="event-tag-cover-empty">赛事图片</div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-7">
              <div class="d-flex flex-column h-100">
                <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                  <span class="badge text-bg-primary">{{ ev.seasonYear }} 赛季</span>
                  <span class="badge text-bg-light border">{{ ev.category }}</span>
                  <span class="badge text-bg-light border" v-if="ev.status">{{ ev.status }}</span>
                </div>
                <div class="event-tag-title">{{ ev.title }}</div>
                <div class="event-tag-desc mt-2">{{ ev.summary }}</div>
                <div class="mt-auto pt-2 text-muted small" v-if="ev.timeText">
                  时间：{{ ev.timeText }}
                </div>
              </div>
            </div>

            <div class="col-12 col-md-3 col-lg-3">
              <div class="d-flex flex-column justify-content-between h-100 gap-2">
                <button type="button" class="btn btn-outline-primary w-100" :disabled="Number(ev.enabled) === 0" @click="openMore(ev)">{{ Number(ev.enabled) === 0 ? '赛事已结束' : (ev.moreButtonText || '查看更多赛事信息') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventPublicIntroView',
  data() {
    return {
      loading: false,
      selectedSeason: null,
      seasons: [],
      heroBanners: [],
      events: []
    }
  },
  computed: {
    seasonOptions() {
      return (this.seasons || []).map((s) => Number(s.year)).filter((n) => Number.isFinite(n))
    },
    filteredEvents() {
      const s = Number(this.selectedSeason)
      return (this.events || []).filter((e) => Number(e.seasonYear) === s)
    }
  },
  async created() {
    await this.loadHome()
  },
  watch: {
    selectedSeason() {
      // reload banners/events by season
      this.loadHome()
    }
  },
  methods: {
    async loadHome() {
      this.loading = true
      try {
        const q = this.selectedSeason ? `?season=${encodeURIComponent(String(this.selectedSeason))}` : ''
        const res = await fetch(`/api/event/public/home${q}`).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '加载失败')
        const data = res.data || {}
        this.seasons = data.seasons || []
        if (!this.selectedSeason) {
          const use = data.season || (this.seasons[0] && this.seasons[0].year)
          this.selectedSeason = use != null ? Number(use) : null
        }
        this.heroBanners = (data.banners || []).map((b) => ({
          url: b.imageUrl,
          title: b.title || '',
          subtitle: b.subtitle || ''
        }))
        this.events = (data.events || []).map((e) => ({
          ...e,
          coverUrl: e.coverUrl
        }))
      } catch (e) {
        window.alert(e.message || '加载赛事信息失败')
      } finally {
        this.loading = false
      }
    },
    openMore(ev) {
      const id = ev && ev.id ? Number(ev.id) : 0
      if (!id) {
        window.alert('赛事ID不存在，无法查看详情')
        return
      }
      window.location.hash = `#/event/detail/${id}`
    }
  }
}
</script>

<style scoped>
.event-hero {
  width: 100%;
}
.event-hero-slide {
  height: 320px;
  background-size: cover;
  background-position: center;
}
@media (min-width: 992px) {
  .event-hero-slide {
    height: 420px;
  }
}
.event-hero-mask {
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.15));
  display: flex;
  align-items: flex-end;
}
.event-hero-content {
  padding: 22px 16px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  color: #fff;
}
.event-hero-title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.event-hero-subtitle {
  margin-top: 6px;
  font-size: 14px;
  opacity: 0.95;
}
.event-public-body {
  padding-top: 18px;
  padding-bottom: 28px;
}
.event-tag-card {
  border-radius: 14px;
  overflow: hidden;
  position: relative;
}
.event-tag-card-ended {
  filter: grayscale(1);
  opacity: 0.78;
}
.event-ended-mark {
  position: absolute;
  right: 16px;
  top: 10px;
  font-size: 48px;
  font-style: italic;
  font-weight: 900;
  color: rgba(120, 120, 120, 0.38);
  transform: rotate(-16deg);
  pointer-events: none;
  z-index: 5;
}
.event-tag-cover {
  width: 100%;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  background: #f2f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .event-tag-cover {
    height: 140px;
  }
}
.event-tag-cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.event-tag-cover-empty {
  color: #9aa4b2;
  font-size: 12px;
}
.event-tag-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}
.event-tag-desc {
  color: #4b5563;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-wrap;
}
</style>

